module.exports = __webpack_public_path__ + "img/l1.fe7975be.png";